/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NavigationEnd, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root', // Ensures it is available throughout the app
})
export class OtaApiService {
  private history = [];
  public img = '';

  private APIService = environment.serviceUrl + 'ota';

  constructor(
    private http: HttpClient,
    public snackBar: MatSnackBar,
    private router: Router
  ) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.history.push(event.urlAfterRedirects);
      }
    });
  }

  getOtaCommandList(
    currentPage,
    pageSize,
    commandType,
    search
  ): Observable<any> {
    return this.http.get(
      this.APIService +
        '/getOTACommandList?page=' +
        currentPage +
        '&size=' +
        pageSize +
        '&commandType=' +
        commandType +
        '&search=' +
        search
    );
  }

  saveOtaMaster(payload): Observable<any> {
    return this.http.post(this.APIService + '/saveOTACommand', payload);
  }

  deleteOTACommand(id): Observable<any> {
    return this.http.delete(`${this.APIService}/deleteOTACommand/${id}`);
  }

  uploadOtaBatch(file: File, payload): Observable<any> {
    const formData = new FormData();

    // Append fields to the FormData object
    formData.append('file', file);
    formData.append('name', payload.batchName);
    formData.append('desc', payload.batchDescription);
    formData.append('comandList', payload.commandList);
    formData.append('userId', payload.userId);

    // Make the POST request
    return this.http.post(this.APIService + '/upload', formData);
  }

  startManualOta(payload): Observable<any> {
    return this.http.post(this.APIService + '/startManualOta', payload);
  }

  getOTABatchList(currentPage, pageSize, search): Observable<any> {
    return this.http.get(
      this.APIService +
        '/getOTABatchList?page=' +
        currentPage +
        '&size=' +
        pageSize +
        '&search=' +
        search
    );
  }

  fetchOtaBatchdetails(
    id,
    search,
    status,
    currentPage,
    pageSize
  ): Observable<any> {
    return this.http.get(
      this.APIService +
        '/getOTABatchDeatil?otaBatchId=' +
        id +
        '&search=' +
        search +
        '&status=' +
        status +
        '&page=' +
        currentPage +
        '&size=' +
        pageSize
    );
  }

  abortOtaDevice(deviceId): Observable<any> {
    return this.http.get(
      this.APIService + '/abortOtaDevice?deviceId=' + deviceId
    );
  }

  abortOtaBatch(batchId): Observable<any> {
    return this.http.get(this.APIService + '/abortOtaBatch?batchId=' + batchId);
  }

  getOtaDeviceDetailByImei(imei): Observable<any> {
    return this.http.get(this.APIService + '/getDetailByImei?imei=' + imei);
  }
}
